import React, {
  useState,
} from 'react';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';


type Item = {
  id: number,
  name: string,
}
type Props = {
  tabs: Item[],
  children: { (): void },
  background: string,
};

const Tab = ({ tabs, children, background }: Props) => {
  const [activeTab, setTab] = useState(1);

  return (
    <Flex column width="100%">
      <S.Header>
        {tabs.map(tab => (tab.tooltip
          ? (
            <Tooltip
              key={tab.id}
              body={tab.tooltip}
              preferPlace="above"
            >
              <S.Tab
                active={tab.id === activeTab}
                onClick={() => setTab(tab.id)}
              >
                {tab.name}
              </S.Tab>
            </Tooltip>
          ) : (
            <S.Tab
              key={tab.id}
              active={tab.id === activeTab}
              onClick={() => setTab(tab.id)}
            >
              {tab.name}
            </S.Tab>
          )))
        }
      </S.Header>
      <S.Content background={background}>
        {children(activeTab)}
      </S.Content>
    </Flex>
  );
};

export default Tab;
